import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {
  className?: string;
}

export default function LanguageSwitcher({ className = '' }: LanguageSwitcherProps) {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const handleLanguageChange = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className={`inline-flex border border-white rounded overflow-hidden ${className}`}>
      <button
        onClick={() => handleLanguageChange('en')}
        className={`px-2 py-1 text-xs font-medium text-center ${currentLang === 'en' ? 'bg-white text-blue-950' : 'text-white hover:bg-white hover:text-blue-950'}`}
      >
        EN
      </button>
      <button
        onClick={() => handleLanguageChange('th')}
        className={`px-2 py-1 text-xs font-medium text-center ${currentLang === 'th' ? 'bg-white text-blue-950' : 'text-white hover:bg-white hover:text-blue-950'}`}
      >
        TH
      </button>
    </div>
  );
}
